// @ts-nocheck
import { ChangeEvent, useState } from "react";

/**
 * Hook to manage state of <Autocomplete />
 */
export const useAutocompleteState = <T>(
  initialValue: unknown = undefined,
  initialHelperText = ""
) => {
  const [value, setValue] = useState<T>(initialValue);
  const [helperText, setHelperText] = useState<string>(initialHelperText);
  const [error, setError] = useState<boolean>(false);
  const [focus, setFocus] = useState<boolean>(false);

  return {
    error,
    focus,
    onFocus: () => {
      setFocus(true);
    },
    onBlur: () => {
      setFocus(false);
    },
    setError: (message: string) => {
      if (message) {
        setHelperText(message);
        setError(true);

        return;
      }

      setHelperText(initialHelperText);
      setError(false);
    },
    onChange: (_, value) => {
      setValue(value);
    },
    helperText,
    value,
  };
};

/**
 * Hook to manage state of <TextField />
 */
export const useTextFieldState = (
  initialValue = "",
  initialHelperText = ""
) => {
  const [value, setValue] = useState<string>(initialValue);
  const [helperText, setHelperText] = useState<string>(initialHelperText);
  const [error, setError] = useState<boolean>(false);
  const [focus, setFocus] = useState<boolean>(false);

  return {
    onFocus: () => {
      setFocus(true);
    },
    onBlur: () => {
      setFocus(false);
    },
    setError: (message: string) => {
      if (message) {
        setHelperText(message);
        setError(true);

        return;
      }

      setHelperText(initialHelperText);
      setError(false);
    },
    onChange: (eventOrValue: string | ChangeEvent<HTMLInputElement>) => {
      if (typeof eventOrValue === "string") {
        setValue(eventOrValue);
        return;
      }

      setValue(eventOrValue.target.value);
    },
    helperText,
    value,
    error,
    focus,
  };
};
